import { push, ref, remove, set, update } from "firebase/database";
import { message } from "antd";
import { getUserId, trackEvent } from "../../helpers";
import { database } from "../../configs";

export default class Sections {
  async create(params) {
    const {
      value,
      establishmentID,
      formatMessage,
      skipMessage = false,
    } = params;

    const name = (value || "").trim();
    if (!name) {
      message.error(formatMessage({ id: "admin.menu.sections.create.error" }));
      return null;
    }

    try {
      const userID = await getUserId();
      const sectionsRef = ref(
        database,
        `${userID}/Establishments/${establishmentID}/Sections`,
      );
      const newSectionRef = push(sectionsRef);

      await set(newSectionRef, {
        id: newSectionRef.key,
        section_name: name,
        section_active: true,
      });

      if (!skipMessage) {
        trackEvent("section_created", {
          establishment_id: establishmentID,
          section_id: newSectionRef.key,
        });
        message.success(formatMessage({ id: "admin.menu.sections.created" }));
      }

      return newSectionRef.key;
    } catch (error) {
      window.console.error("Error creating section:", error);
      if (!skipMessage) {
        message.error(
          formatMessage({ id: "admin.menu.sections.create.error" }),
        );
      }
      return null;
    }
  }

  async update(establishmentID, id, fieldParams, formatMessage) {
    try {
      const userID = await getUserId();
      const updateListRef = ref(
        database,
        `${userID}/Establishments/${establishmentID}/Sections/${id}`,
      );

      await update(updateListRef, fieldParams);

      message.success(formatMessage({ id: "admin.menu.sections.updated" }));
    } catch (error) {
      message.error(formatMessage({ id: "admin.menu.sections.update.error" }));
    }
  }

  async delete(establishmentID, id, formatMessage) {
    try {
      const userID = await getUserId();
      const deleteListRef = ref(
        database,
        `${userID}/Establishments/${establishmentID}/Sections/${id}`,
      );

      await remove(deleteListRef);

      trackEvent("section_deleted", {
        establishment_id: establishmentID,
        section_id: id,
      });

      message.success(formatMessage({ id: "admin.menu.sections.deleted" }));
    } catch (error) {
      message.error(formatMessage({ id: "admin.menu.sections.delete.error" }));
    }
  }

  async activateDeactivate(
    establishmentID,
    id,
    activateDeactivateParams,
    formatMessage,
  ) {
    try {
      const userID = await getUserId();
      const activateDeactivateListRef = ref(
        database,
        `${userID}/Establishments/${establishmentID}/Sections/${id}`,
      );

      await update(activateDeactivateListRef, activateDeactivateParams);

      message.success(formatMessage({ id: "admin.menu.sections.updated" }));
    } catch (error) {
      message.error(formatMessage({ id: "admin.menu.sections.update.error" }));
    }
  }

  async reorder(establishmentID, updatedItems, formatMessage) {
    try {
      const userID = await getUserId();
      const createListRef = ref(
        database,
        `${userID}/Establishments/${establishmentID}/Sections`,
      );

      await update(createListRef, updatedItems);

      message.success(formatMessage({ id: "admin.menu.sections.reordered" }));
    } catch (error) {
      message.error(formatMessage({ id: "admin.menu.sections.reorder.error" }));
    }
  }
}
